import { useGenerateDashboardTokenQuery } from '@app/graphql'
import { useEffect } from 'react'
import { Zeelix } from '@zeelix/sdk'
import styled from 'styled-components'
import { useSnapshot } from 'valtio'
import { useNavigate } from 'react-router-dom'
import { CurrentUserState } from '@app/storage'
import { Icon, IconTypes, IconColor } from '@app/ui'
import { useTranslation } from 'react-i18next'

const DashboardContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  
  #zeelix {
    width: 100%;
    height: 100%;
  }
`

const CustomHeader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: white;
  padding: 16px 24px;
  border-bottom: 1px solid #e0e0e0;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  h1 {
    flex: 1;
    text-align: center;
    margin: 0;
    font-size: 20px;
  }
  
  .back-button {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: transparent;
    border: none;
    padding: 8px;
  }
  
  .spacer {
    width: 40px;
  }
`

const IframeWrapper = styled.div`
  padding-top: 64px;
  height: 100%;
  
  iframe {
    border: none;
    outline: none;
  }
`

export const Dashboard = () => {
  const { t } = useTranslation()
  const sumboard = new Zeelix()
  const dashboardId = '8GCmGMkpJbJcW'
  const navigate = useNavigate()
  const { data, loading, error } = useGenerateDashboardTokenQuery({
    fetchPolicy: 'network-only'
  })
  const token = data?.generateDashboardToken
  const {
    name,
    surname,
    username,
  } = useSnapshot(CurrentUserState)
  const displayName = name || surname ? `${name || ''} ${surname || ''}`.trim() : username

  useEffect(() => {
    if (token) {
      sumboard.init({ token, dashboardId })
    }
  }, [ token ])

  const handleBack = () => {
    navigate(-1)
  }

  if (loading) return <div>{t('common.loading')}</div>
  if (error) return <div>{t('dashboard.error')} {error.message}</div>

  return (
    <DashboardContainer>
      <CustomHeader>
        <button className="back-button" onClick={handleBack}>
          <Icon
            type={IconTypes.angleLeft}
            color={IconColor.fontBlack}
            width={25}
            height={25}
          />
        </button>

        <h1>{t('dashboard.displaynameStatistics', { displayName })}</h1>

        <div className="spacer" />
      </CustomHeader>

      <IframeWrapper>
        <div id="zeelix"></div>
      </IframeWrapper>
    </DashboardContainer>
  )
}